import { render, staticRenderFns } from "./PerformanceProductLineDetail.vue?vue&type=template&id=5dd7411e&scoped=true&"
import script from "./PerformanceProductLineDetail.vue?vue&type=script&lang=js&"
export * from "./PerformanceProductLineDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd7411e",
  null
  
)

export default component.exports